// extracted by mini-css-extract-plugin
export var cardIcon = "_az-5";
export var cardIconUnframed = "_az-9";
export var checkboxCard = "_az-0";
export var checkboxCardSelected = "_az-4";
export var disabled = "_az-2";
export var interactive = "_az-1";
export var outerBorder = "_az-3";
export var spacerMedium = "_az-8";
export var spacerSmall = "_az-7";
export var spacerXsmall = "_az-6";